import cls from 'classnames';

import { InputVariant } from '.';

const smallText = 'text-small mt-1';

const styles = {
  inputWrapper: 'w-full',
  label: (showLabel: boolean) =>
    cls('text-overline mb-2', !showLabel && 'hidden'),
  input: (variant: InputVariant, hasError = false, blur = false) =>
    cls(
      'w-full rounded-2 py-3 px-4 leading-snug',
      variant !== 'profile' &&
        variant !== 'profileModal' &&
        'focus:shadow-none focus:ring-0',
      !hasError &&
        variant !== 'profileModal' &&
        'border-transparent focus:border-gray-2',
      variant === 'newsletter' &&
        'text-red-light bg-black bg-opacity-50 focus:border-gray-2 tesn:bg-air-lila-light tesn:bg-opacity-20',
      variant === 'profile' &&
        'text-white bg-black-light focus:ring-1 focus:ring-gray-2 focus:border-gray-2',
      variant === 'profileModal' &&
        'text-white bg-black border border-gray-1 focus:ring-1 focus:ring-gray-2 focus:border-gray-2',
      'teair:bg-air-mediumBlue teair:bg-opacity-20 teair:text-air-mediumBlue teair:placeholder-white',
      variant === 'quiz' && 'teair:bg-white teair:border-black border-2',
      hasError &&
        blur &&
        'border-red-medium focus:border-red-medium ring-1 ring-red-medium',
    ),
  helperText: cls('text-gray-2', smallText),
  errorText: cls('text-red-medium', smallText),
};

export default styles;
